import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createWorkerCredential } from 'api/admin/credentials/createWorkerCredential'
import { credentialsKeys } from './keys'
import { userKey } from 'queries/user/keys'

export function useCreateWorkerCredentialMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createWorkerCredential,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: credentialsKeys.workerRequirements(),
      })
      await queryClient.invalidateQueries({
        queryKey: userKey,
      })
    },
  })
}
